import { withStyles } from '@material-ui/core';
import { MapAutoZoom, MapLegendToggle } from '../../../../../layout/layoutHeader/components';
import { CustomMenu } from '../../../../common/MUI';

const styles = (theme) => ({
  toggledMenu: {
    display: 'inline'
  },
  anchorPointHeader: {
    color: theme.HeaderSelectedText,
    borderBottom: `1px solid ${theme.AppBGColor}`,
    fontWeight: 'bold',
    paddingLeft: 16,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
});

const MapHeader = ({
  classes,
  eventHub,
  isAutoZoomEnabled,
  isMapLegendEnabled,
  toggleRouteAnimation,
  toggleMapLegend,
  ...other
}) => {
  return (
    <header className={classes.anchorPointHeader} data-automationid="anchorPointMap-title">
      Anchor Point Map
      <div className={classes.toggledMenu}>
        <CustomMenu
          classes={classes}
          menuContent={
            <>
              <MapAutoZoom
                isEnabled={isAutoZoomEnabled}
                isMenuItem
                toggleRouteAnimation={toggleRouteAnimation}
                eventHub={eventHub}
                title={`${isAutoZoomEnabled ? 'Disable' : 'Enable'} Auto Zoom`}
                {...other}
              />
              <MapLegendToggle
                isMapLegendEnabled={isMapLegendEnabled}
                isMenuItem
                toggleMapLegend={toggleMapLegend}
                {...other}
              />
            </>
          }
        />
      </div>
    </header>
  );
};

export default withStyles(styles)(MapHeader);
